/**
 * @voltxampere/ui — JST PH 2.0mm connector (Sprint 45-6, schema-only)
 *
 * Schema-only passthrough — engine'de davranış yok. 2-pin JST PH
 * 2.0 mm pitch power connector — hobbyist drone / RC + LiPo
 * battery + LED strip standardı.
 *
 * Reference: JST B2B-PH-K-S — 2.0 mm pitch PCB header. 2 A current,
 * 100 V dielectric. Mini quadcopter battery, ESP32 dev board power,
 * Adafruit Feather BMS.
 *
 * Engine zero-diff invariant honored — canonical `wire-node`
 * engine type via schemaType (passthrough).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { node } from "../node.js";
export const connectorJstPh = {
    id: "jst-ph",
    nameTr: "JST PH 2.0mm (2-pin power, schema-only)",
    nameEn: "JST PH 2.0mm (2-pin power, schema-only)",
    shortcut: "N",
    category: "connector",
    viewBox: node.viewBox,
    terminals: node.terminals,
    defaultLabel: "J",
    defaultValue: "JST-PH",
    schemaType: "wire-node",
    defaultParams: {},
    renderSVG: () => node.renderSVG(),
};
//# sourceMappingURL=connector-jst-ph.js.map